import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { getVatWidget } from "../../../store/actions/precog/vat";
import WidgetsPrecogCard from "./card";
import numeral from "numeral";

const WidgetVatSummary = () => {
  // MONTHLY o QUARTERLY
  
  const dispatch = useDispatch();
  const intl = useIntl();

  const [isLoadingWidget, setIsLoadingWidget] = useState(true);
  const [periodType, setPeriodType] = useState(null);
  /** se trimestrale trimestre corrente altrimenti mese corrente */
  const [currentPeriod, setCurrentPeriod] = useState(null);
  /** se trimestrale trimestre passato altrimenti mese passato */
  const [lastPeriod, setLastPeriod] = useState(null);
  /** anno precedente rispetto a periodo corrente */
  const [lastYear, setLastYear] = useState(null);

  useEffect(() => {
    dispatch(getVatWidget()).then((res) => {
      setPeriodType(res?.type);
      setCurrentPeriod({
        title: res?.type === "MONTHLY" ? moment().format("MMMM YY") : `${moment().quarter()}° ${intl.formatMessage({id: "preCog.widget.vatSummary.quater"})} ${moment().format("YYYY")}`,
        amount: res?.actual || "-"
      });
      setLastPeriod({
        title: res?.type === "MONTHLY" ? moment().subtract(1, "M").format("MMMM YY") : `${moment().subtract(1, "Q").quarter()}° ${intl.formatMessage({id: "preCog.widget.vatSummary.quater"})}  ${moment().subtract(1, "Q").format("YYYY")}`,
        amount: res?.lastPeriod || "-"
      });
      setLastYear({
        title: res?.type === "MONTHLY" ? moment().subtract(1, "Y").format("MMMM YY") : `${moment().subtract(1, "Y").quarter()}° ${intl.formatMessage({id: "preCog.widget.vatSummary.quater"})} ${moment().subtract(1, "Y").format("YYYY")}`,
        amount: res?.lastYearPeriod || "-"
      });
      
      setIsLoadingWidget(false);
    });   
  }, []);

  const renderItemVat = (title, amount) => {
    return (
      <div className={"vatItemRow"}>
        <div style={{flex: "1 0 auto"}}>
          {title}
        </div>
        <div style={{fontWeight: "bold", color: amount < 0 ? "#d82829" : "initial"}}>
          {`${numeral(amount).format("0,0.00")} €`}
        </div>
        <div>
          {/* TODO variazione percentuale */}
        </div>
      </div>
    );
  };

  return  (
    <WidgetsPrecogCard isEmpty={false}>
      <div className="title" data-testid="titleWidget"
        style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <FormattedMessage id="preCog.widget.vatSummary.title"/>
        {periodType && <FormattedMessage id={`preCog.widget.vatSummary.${periodType?.toLowerCase()}`} />}      
      </div>
      <div className="subtitle"></div>
      {
        isLoadingWidget ? 
          <div 
            style={{display: "flex", 
              alignItems: "center",
              width: "100%",
              justifyContent: "center"}}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{
                fontSize: "40px",
                color: "#1890ff"
              }}
            />
          </div> :
          <div>
            {renderItemVat(`${intl.formatMessage({id: "preCog.widget.vatSummary.vat"})} ${currentPeriod?.title}`, 
              currentPeriod?.amount)}
            {renderItemVat(`${intl.formatMessage({id: "preCog.widget.vatSummary.vat"})} ${lastPeriod?.title}`, 
              lastPeriod?.amount)}
            {renderItemVat(`${intl.formatMessage({id: "preCog.widget.vatSummary.vat"})} ${lastYear?.title}`, 
              lastYear?.amount)}

          </div>
      }
    </WidgetsPrecogCard>
  );
};

export default WidgetVatSummary;
